import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { messages } from "src/app/resources/messages";

export function dateRange(fromDate: string, toDate: string, range: number): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    const fromDateVal = control.get(fromDate)?.value ? control.get(fromDate)?.value : control.value[fromDate];
    const toDateVal = control.get(toDate)?.value ? control.get(toDate)?.value : control.value[toDate];

    if ((fromDateVal !== null && toDateVal !== null) && (fromDateVal !== "" && toDateVal !== "")) {

      const fromDate: any = new Date(fromDateVal);
      const toDate: any = new Date(toDateVal);
      const diffTime = Math.abs(toDate - fromDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (fromDate > toDate) {
        return { dateRange: true, errorMsg: messages.FormValidationMessage.InvalidDateRange };
      } else if (diffDays > range) {
        return { dateRange: true, errorMsg: messages.FormValidationMessage.DateRangeLimit + range +" days" };
      }
    }
    return null;
  }
}